import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  darkMode = signal(false);

  toggleTheme() {
    this.darkMode.update(v => !v);
  }
}
